import styled from "styled-components"

export const Holder = styled.div`
  width: 35vw;
  height: 100%;
  user-select: none;
  pointer-events: none;
  position: relative;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  background-color: #75938f;
`

export const TitleHolder = styled.div`
  width: 100%;
  padding: 0 1vw;
`
export const TitleImage = styled.img`
  width: 100%;
`
export const Tip = styled.div`
  width: 100%;
  padding: 4vw 4vw 6vw 4vw;
  font-family: AzoSans-Regular;
  font-size: 1vw;
  color: white;
  letter-spacing: 0.1em;
  line-height: 150%;
`
